<template>
  <v-app>
    <navigation />
    <v-main>
      <router-view />
    </v-main>
		<v-scale-transition>
			<v-btn
				fab
				v-show="fab"
				v-scroll="onScroll"
				dark
				fixed
				bottom
				right
				color="secondary"
				@click="toTop"
			>
				<v-icon>mdi-arrow-up</v-icon>
			</v-btn>
		</v-scale-transition>
		<app-footer />
  </v-app>
</template>


<script>
import navigation from '@/components/Navigation'
import AppFooter from '@/components/Footer'

export default {
  name: 'App',
  components: {
    navigation,
		AppFooter
  },
	methods: {
		onScroll(e) {
			if (typeof window === 'undefined') return
			const top = window.pageYOffset || e.target.scrollTop || 0
			this.fab = top > 60
		},
		toTop() {
			this.$vuetify.goTo(0)
		}
	},
  data: () => ({
		fab: null,
		color: '',
		flat: false
  }),
	created() {
		this.color = 'light-blue lighten-5'
	},
}
</script>

<style lang="scss">
.page-header {
	height: 200px;
	overflow: hidden;
	position: relative;
	&:after {
		position: absolute;
		inset: 0;
		background-color: rgba(255,255,255,.5);
		display: block;
		content: "";
		z-index: 0;
	}
	.page-title {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10;
	}
}
</style>